export const PAYMENT_PROVIDER_NAME = {
    STRIPE: 'STRIPE',
    KG_INICIS: 'KG_INICIS',
};
